import { useDropzone } from 'react-dropzone';
import Upload from './../../../images/upload.svg';

export default function Dropzone({ onDrop, accept, disabled }) {
	const { getRootProps, getInputProps, open } = useDropzone({
		onDrop,
		accept,
		multiple: false,
		noClick: true,
		noKeyboard: true,
		disabled,
	});

	return (
		<div className='upload-box' {...getRootProps()}>
			<input {...getInputProps()} className='file-input' />

			<div className='icon'>
				<img src={Upload} alt='file upload' />
			</div>

			<p>
				Drag and Drop or <span onClick={open}>Browse</span> to upload
			</p>
		</div>
	);
}
